import { useState } from 'react';
import CodeSnippet from '../CodeSnippet';

const LANGUAGES = [
  { id: 'python', label: 'Python' },
  { id: 'javascript', label: 'JavaScript' },
  { id: 'bash', label: 'Env vars' },
];

function buildSnippets(base, token) {
  return {
    python: {
      language: 'python',
      code: `# Before (OpenRouter)
from openai import OpenAI

client = OpenAI(
    base_url="https://openrouter.ai/api/v1",
    api_key="sk-or-...",
)

# After (os-router)
client = OpenAI(
    base_url="${base}",
    api_key="${token}",
)`,
    },
    javascript: {
      language: 'javascript',
      code: `// Before (OpenRouter)
import OpenAI from "openai";

const client = new OpenAI({
  baseURL: "https://openrouter.ai/api/v1",
  apiKey: "sk-or-...",
});

// After (os-router)
const client = new OpenAI({
  baseURL: "${base}",
  apiKey: "${token}",
});`,
    },
    bash: {
      language: 'bash',
      code: `# Before (OpenRouter)
export OPENAI_BASE_URL="https://openrouter.ai/api/v1"
export OPENAI_API_KEY="sk-or-..."

# After (os-router)
export OPENAI_BASE_URL="${base}"
export OPENAI_API_KEY="${token}"`,
    },
  };
}

export default function IntegrateOpenRouter({ apiUrl, tokenPlaceholder }) {
  const [lang, setLang] = useState('python');
  const base = `${apiUrl || 'https://api.osrouter.dev'}/api/v1`;
  const snippets = buildSnippets(base, tokenPlaceholder);
  const active = snippets[lang];

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Replace OpenRouter</h1>
      <p className="text-sm opacity-60 mb-6">
        os-router is a drop-in replacement for OpenRouter. Swap the base URL and API key. Your existing
        OpenAI-compatible client code can stay the same.
      </p>

      <CodeSnippet
        code={active.code}
        language={active.language}
        languages={LANGUAGES}
        activeLanguage={lang}
        onLanguageChange={setLang}
      />
      <p className="text-sm opacity-60 mt-4">
        os-router base URL: <code className="text-theme-primary">{base}</code>
      </p>
    </div>
  );
}
